module.exports = __webpack_public_path__ + "assets/b063f83be2f6efb86f755f97ff0b20e4.png";